import { h, Component } from 'preact';
// import * as actions from 'store/actions';
import { isDemoTicketing } from 'store/ticketingPublic';
import { getCopy } from 'utils/copy';
import { accessNested, isObject, displayWhen } from 'utils/utils';
import { Link } from 'components/core/link/link';
import PaymentLoader from 'components/shared/theaters/ticketing/gateways/paymentLoader';
import s from 'components/shared/theaters/ticketing/gateways/verifone2PaymentGateway/verifone2PaymentGateway.sss';


const VERIFONE2_URL_LIVE = '';
// const VERIFONE2_URL_LIVE = 'https://pp2.cxmlpg.com/paypage.aspx';
// NOTE: Please contact Verifone to get the live gateway URL
//       <James.Monks@verifone.com>
//       <Mark.Jenkinson@verifone.com>
const VERIFONE2_URL_CST = 'https://paypage2-cst.cxmlpg.com/paypage.aspx';
const VERIFONE2_URL = isDemoTicketing() === 'production' ? VERIFONE2_URL_LIVE : VERIFONE2_URL_CST;

const VERIFONE2_IFRAME_LOADING_TIME_MS = 3500;

const Verifone2Logo = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 445 90" {...props}>
		<path d="M228.86 5.418c-18.276.171-20.354 14.354-22.298 24.078h-8.109l-2.517 12.783h8.197l-5.854 29.674c-2.356 11.942 8.054 12.342 14.198 9.813l7.757-39.487h12.532l2.48-12.783h-12.523c1.575-11.054 5.593-12.966 15.66-10.482L240.78 6.88c-4.597-1.047-8.537-1.495-11.922-1.463zm-49.405 2.387l-2.627 13.32h16.234l2.682-13.32h-16.289zm-165.58 3.96v55.012c0 23.084 24.386 17.423 27.596 8.49-5.742 1.213-11.19-3.114-11.19-11.484V11.766H13.875zm321.75 16.516c-13.24 0-17.14 10.365-17.14 10.365l.51-9.148h-16.022c-.818 13.531-4.501 26.15-7.338 42.342-2.418 13.798 10.178 11.535 14.31 9.957l5.485-27.955c1.364-6.955 7.28-11.763 12.976-11.631 4.486.104 8.69 3.26 7.469 9.492l-3.707 18.92c-2.78 14.185 7.8 13.015 14.182 11.18l5.712-29.834s4.632-23.688-16.437-23.688zm-239.688.016c-17.898-.138-29.53 14.599-29.53 30.969 0 15.755 11.8 23.802 25.782 23.802 14.316 0 20.12-8.185 18.952-14.287-18.181 6.109-28.987-.072-28.987-7.804h36.596c3.112-12.994 1.44-32.493-22.813-32.68zm291.858 0c-17.899-.138-29.531 14.599-29.531 30.969 0 15.755 11.8 23.802 25.783 23.802 14.315 0 20.12-8.185 18.951-14.287-18.18 6.109-28.986-.072-28.986-7.804h36.595c3.113-12.994 1.441-32.493-22.812-32.68zm-122.293.047c-18.113 0-29.886 10.108-31.873 27.343-1.854 16.08 7.912 27.138 25.182 27.313 17.174.174 30.177-9.79 31.935-27.25 1.74-17.278-9.006-27.406-25.244-27.406zm-103.018.05c-8.108-.315-13.016 4.317-15.468 10.278l.603-9.14h-16.025c-.754 11.273-4.69 27.75-7.406 41.812-2.2 11.382 5.408 13.288 14.316 10.48l4.994-25.72c1.885-9.711 6.4-16.917 22.33-12.674l2.79-13.98c-2.222-.645-4.263-.983-6.134-1.055zm266.172.024c-4.42 0-8.396 3.639-8.875 8.103-.479 4.465 2.717 8.104 7.137 8.104s8.394-3.639 8.873-8.104c.479-4.464-2.715-8.103-7.135-8.103zm-.107.996c3.867 0 6.66 3.171 6.238 7.107-.422 3.937-3.894 7.108-7.762 7.108-3.867 0-6.662-3.171-6.24-7.108.422-3.936 3.896-7.107 7.764-7.107zm-237.049.117l-16.281.022-8.313 42.431c-1.759 8.985 3.669 13.266 14.278 9.86L191.5 29.53zm234.797 2.14l-1.881 9.337h1.022l.843-4.422h1.469l1.656 4.422h1.156l-1.843-4.492c3.608 0 3.866-4.808.328-4.828l-2.75-.016zm.742.868h1.922c2.373 0 2.136 3.145-.39 3.145h-2.134l.602-3.145zM95.592 41.012c8.815 0 8.793 8.679 8.242 9.633H83.416s2.65-9.633 12.176-9.633zm291.857 0c8.815 0 8.793 8.679 8.242 9.633h-20.418s2.651-9.633 12.176-9.633zm-123.566.021c5.361.006 10.662 3.254 10.638 10.738-.026 8.361-4.22 18.606-14.394 18.606-7.987 0-10.512-6.413-10.28-11.654.53-11.937 7.293-17.697 14.036-17.69z" />
		<path d="M34.752 58.26l29.554-46.495h17.076l-34.943 55.79c-3.464 5.481-11.748 4.561-11.67-3.27z" fill="#00adef" />
	</svg>
);


export default class Verifone2PaymentGateway extends Component {

	constructor() {
		super();
		this.$iframe = null;

		this.state = {
			loading: true
		};

		this.checkIframeLocation = this.checkIframeLocation.bind(this);
	}

	componentDidMount() {
		this.$form.submit();
		this.timer = setInterval(this.checkIframeLocation, 300);

		const that = this;
		setTimeout(() => that.setState({ loading: false }), VERIFONE2_IFRAME_LOADING_TIME_MS);
	}

	componentWillUnmount() {
		clearInterval(this.timer);
	}

	/**
	 * Handle the "Cancel" button of the Verifone PP2 iframe.
	 * Note that we could have used another thundr base to handle this.
	 */
	checkIframeLocation() {
		try {
			if (this.$iframe.contentWindow.location.href === window.location.href) {
				// Location has changed, so the user has pressed cancel
				// Go back to the previous step
				// Store.emit(actions.GO_TICKETING_REVIEW);
			}
		} catch (err) {
			// console.error('Error:', err);
		}
	}

	render(props, { loading }) {
		const {
			ticketing, // Object - the ticketing state
			theater
		} = props;

		const theaterName = accessNested(ticketing, 'meta.theaterName');

		const { paymentData } = ticketing;
		const payload = isObject(paymentData) ? paymentData.payload : paymentData;

		return (
			<div class={s.container}>
				<header class={s.header}>
					<h2 class={s.title}>{getCopy('PROVIDE_PAYMENT_INFO', { THEATER_NAME: theaterName })}</h2>
				</header>
				<div class={s.iframeWrapper}>
					<iframe
						class={s.iframe}
						name="verifone2Iframe"
						style={displayWhen(!loading)}
						ref={$ref => this.$iframe = $ref}
					/>
					<PaymentLoader style={displayWhen(loading)}>
						<Verifone2Logo />
					</PaymentLoader>
					<form class={s.tmpForm} method="POST" action={VERIFONE2_URL} target="verifone2Iframe" ref={ref => this.$form = ref}>
						<input type="hidden" name="postdata" value={payload} />
					</form>
				</div>
				<footer class={s.footer}>
					<p>
						<svg class={s.lockIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
							<path d="M50.164 13.896c-12.817 0-23.292 10.446-23.342 23.252v6.956h-1.029a4.283 4.283 0 0 0-4.293 4.294v33.414a4.283 4.283 0 0 0 4.293 4.292h48.414a4.283 4.283 0 0 0 4.293-4.292V48.398a4.283 4.283 0 0 0-4.293-4.294h-.703v-6.956c-.05-12.806-10.523-23.252-23.34-23.252zm0 7.5c8.763 0 15.789 7 15.838 15.752v6.956H34.324v-6.956a15.785 15.785 0 0 1 15.84-15.752zM50 54.426a6.045 6.045 0 0 1 6.045 6.046 6.045 6.045 0 0 1-3.945 5.664l.9 7.152h-6l.9-7.154a6.045 6.045 0 0 1-3.945-5.662A6.045 6.045 0 0 1 50 54.427z" />
						</svg>
						<span class={s.encryption}>SSL Encryption</span>
						<span>powered by</span>
						<Link class={s.verifone2Logo} target="_blank" href="http://www.verifone.co.uk/" renderCustomChild>
							<Verifone2Logo />
						</Link>
					</p>
				</footer>
			</div>
		);
	}

}
